import React from 'react';
import FloatingAlerts from '../../../shared/ui/floating-alerts/floating-alerts.jsx';
import LoadingContainer from '../../../shared/ui/loading-container/loading-container.jsx';
import PageHeader from '../../../shared/ui/page-header/page-header.jsx';

function MarketingEmailSettingsPageView({
  form,
  isLoading,
  isSaving,
  error,
  success,
  formErrors,
  onFormChange,
  saveSettings,
}) {
  return (
    <div>
      <FloatingAlerts info={isSaving ? 'Saving marketing email settings...' : ''} error={error} success={success} />
      <PageHeader title="Marketing email settings" subtitle="Control native sending batch size and the required unsubscribe footer." />

      <div className="widget-content searchable-container list">
        <div className="card card-body">
          <LoadingContainer isLoading={isLoading} hasData>
            <form onSubmit={saveSettings}>
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label">Default batch size</label>
                  <input
                    type="number"
                    min="1"
                    max="1000"
                    step="1"
                    className={`form-control ${formErrors.defaultBatchSize ? 'is-invalid' : ''}`}
                    value={form.defaultBatchSize}
                    onChange={(event) => onFormChange('defaultBatchSize', event.target.value)}
                    disabled={isSaving}
                    required
                  />
                  {formErrors.defaultBatchSize ? <div className="invalid-feedback">{formErrors.defaultBatchSize}</div> : null}
                </div>
                <div className="col-12">
                  <label className="form-label">Unsubscribe footer text</label>
                  <textarea
                    className={`form-control ${formErrors.unsubscribeFooterText ? 'is-invalid' : ''}`}
                    rows="4"
                    value={form.unsubscribeFooterText}
                    onChange={(event) => onFormChange('unsubscribeFooterText', event.target.value)}
                    disabled={isSaving}
                    required
                  ></textarea>
                  {formErrors.unsubscribeFooterText ? <div className="invalid-feedback">{formErrors.unsubscribeFooterText}</div> : null}
                </div>
              </div>

              <div className="d-flex justify-content-end gap-2 mt-4">
                <button type="submit" className="btn btn-primary" disabled={isLoading || isSaving}>
                  {isSaving ? 'Saving...' : 'Save settings'}
                </button>
              </div>
            </form>
          </LoadingContainer>
        </div>
      </div>
    </div>
  );
}

export default MarketingEmailSettingsPageView;
